import axios from 'axios'
import SearchUrlBuilder from '@/core/utils/SearchUrlBuilder'

class OdontogramaApiClient {

    async buscarOdontograma(dados) {
        const url = SearchUrlBuilder.buildAvanced('/odontograma/buscarOdontograma', dados)
        return axios.get(url)
    }

}

export default new OdontogramaApiClient()